import {
  ApplicantChallengeModel,
  ApplicantChallengeResultModel,
} from "@shared/models";
import {
  ChallengeResultStatus,
  ChallengeStyle,
  ProgrammingLanguage,
} from "@shared/services/enums";

export function isShowCodingChallengeConfirm(
  challenge: ApplicantChallengeModel,
): boolean {
  const { style, localExamEnabled } = challenge;

  // NOTE: CodingChallengeConfirm will show up on the later wheen localExamEnabled is true
  return ChallengeStyle.hasLocalExam(style) && !localExamEnabled;
}

export function isShowCLIPreRequirements(
  challenge: ApplicantChallengeModel,
): boolean {
  const { style, localExamEnabled } = challenge;
  return ChallengeStyle.hasLocalExam(style) && localExamEnabled;
}

export function getCurrentProgrammingLanguage(
  challenge: ApplicantChallengeModel,
  challengeResult?: ApplicantChallengeResultModel,
): ProgrammingLanguage {
  return challengeResult &&
    challengeResult.status === ChallengeResultStatus.CanRestart
    ? challengeResult.programmingLanguage
    : challenge.programmingLanguages && challenge.programmingLanguages[0];
}

export function getCurrentFrontendTemplate(
  challenge: ApplicantChallengeModel,
  challengeResult?: ApplicantChallengeResultModel,
): string {
  return challengeResult?.codingTemplate &&
    challengeResult.status === ChallengeResultStatus.CanRestart
    ? challengeResult.codingTemplate.templateCode
    : challenge.frontendStyleConfig?.allowedTemplateSeriesCodes?.[0] ||
        "react-js";
}
